import { Board, BoardOrder } from 'types';

export default function getOrder(orderId: string, board: Board) {
  return board?.orders?.find((order: BoardOrder) => order?._id === orderId);
}
